import CrudModel from '@/orm/models/CrudModel';
import Vacancy from '@/orm/models/Vacancy/Vacancy';

export default class VacanciesListVacancies extends CrudModel {
  static url = { index: 'vacancy_lists/vacancies' }

  static entity = 'VacanciesListVacancies'

  static primaryKey = 'id'

  static fields() {
    return { ...Vacancy.fields(), address: this.attr(null), publishedTillLessThanMonth: this.attr(false) };
  }
}
